import { Breadcrumbs } from '@/components/Breadcrumbs/Breadcrumbs';
import { Container } from '@/components/Container/Container';
import { RegisterForm } from '@/components/Forms/RegisterForm/RegisterForm';
import { PublicPage } from '@/components/Page/PublicPage';
import { ESize } from '@/models/enums';
import { NextPage } from 'next';

const RegisterNextPage: NextPage = () => {
  return (
    <PublicPage
      meta={{
        seoDescription:
          'Sign up today to create your account and unlock exclusive features, personalized content, and more. Fast and secure registration for a tailored experience.',
        seoTitle: 'Create an account | Register for access',
      }}
      title="Register"
    >
      <Container additionalClassNames="py-12" size={ESize.XS}>
        <div className="mb-2">
          <Breadcrumbs items={[{ content: <span>Register</span>, key: 'Register' }]} />
        </div>
        <h1 className="color-black text-uppercase mb-4">Register</h1>
        <RegisterForm />
      </Container>
    </PublicPage>
  );
};

export default RegisterNextPage;
